import styles from './index.module.scss';
import { CgMenuRightAlt } from 'react-icons/cg';
import { FaCompass } from 'react-icons/fa';
import { mediaAsset } from '../../utils/media';
const Logo = mediaAsset('assets/logo_NTP.png');
const CloseIcon = mediaAsset('assets/close.png');
const WHATSAPP = mediaAsset('assets/Whatsapp.svg');
const YOUTUBE = mediaAsset('assets/youtube.svg');
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { FaSearch, FaSun, FaMoon } from 'react-icons/fa';
import { useTours } from '../../context/TourContext';
import { tourPath } from '../../utils/tourUrls';

const Index = () => {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  const { tours: ExploreContent } = useTours();
  const [navOpen, setNavOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showResults, setShowResults] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const searchRef = useRef(null);

  // Handle search query changes
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim().length >= 2) {
      // Filter tours based on the search query
      const results = ExploreContent.filter(tour => {
        const title = tour.title.toLowerCase();
        const location = tour.location.toLowerCase();
        const queryLower = query.toLowerCase();

        return title.includes(queryLower) || location.includes(queryLower);
      }).slice(0, 5); // Limit to 5 results

      setSearchResults(results);
      setShowResults(true);
    } else {
      setShowResults(false);
    }
  };

  // Close search results when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowResults(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <div className={styles.navbar}>
        <div onClick={() => navigate('/')} className={styles.navbar_logo}>
          <img
            src={Logo}
            loading='lazy'
            alt='NTP Tourism'
            width='90'
            height='90'
            style={{
              width: '90px',
            }}
          />
        </div>

        <div className={styles.nav_right}>
          {/* Search Bar */}
          <div className={styles.search_container} ref={searchRef}>
            <div className={styles.search_input_container}>
              <FaSearch className={styles.search_icon} />
              <input
                type="text"
                placeholder="Search tours..."
                value={searchQuery}
                onChange={handleSearchChange}
                className={styles.search_input}
                aria-label="Search tours"
              />
            </div>

            {showResults && searchResults.length > 0 && (
              <div className={styles.search_results}>
                {searchResults.map((tour) => (
                  <div
                    key={tour.id}
                    className={styles.search_result_item}
                    onClick={() => {
                      navigate(tourPath(tour));
                      setSearchQuery('');
                      setShowResults(false);
                    }}
                  >
                    <div className={styles.search_result_title}>{tour.title}</div>
                    <div className={styles.search_result_location}>{tour.location}</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className={styles.nav_list}>
            <NavList />
          </div>
          {navOpen && (
            <div>
              <NavListC
                navigate={navigate}
                setNavOpen={setNavOpen}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                handleSearchChange={handleSearchChange}
                searchResults={searchResults}
                showResults={showResults}
                setShowResults={setShowResults}
              />
            </div>
          )}
          <button
            type="button"
            className={styles.theme_toggle}
            onClick={toggleTheme}
            aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
            title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
          >
            {theme === 'light'
              ? <FaMoon aria-hidden="true" focusable="false" />
              : <FaSun aria-hidden="true" focusable="false" />}
          </button>
          <button
            type="button"
            className={styles.nav_menu}
            onClick={() => {
              setNavOpen(true);
            }}
            aria-label="Open navigation menu"
            aria-controls="mobile-navigation"
            aria-expanded={navOpen}
          >
            <CgMenuRightAlt aria-hidden="true" focusable="false" />
          </button>
        </div>
      </div>
    </div>
  );
};

const NavList = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.nav_list}>
        {/* <div onClick={() => navigate('/')} className={styles.nav_list__item}>
          Tour
        </div> */}
        <div
          onClick={() => navigate('/about')}
          className={styles.nav_list__item}
        >
          About Us
        </div>
        <div
          onClick={() => {
            navigate('/departure');

            // setExplorePopup(true);
            // navigate('/explore/' + id);
          }}
          className={styles.nav_list__item}
        >
          Departure Date
        </div>
        <div
          onClick={() => navigate('/discover')}
          className={styles.nav_list__item}
        >
          <FaCompass className="inline-block mr-1" /> Discover
        </div>
        <div
          onClick={() => navigate('/gallery')}
          className={styles.nav_list__item}
        >
          Gallery
        </div>
        <Link to="/faqs" className={styles.nav_list__item}>
          FAQs
        </Link>

        {/* <div
          onClick={() => navigate('/blogs')}
          className={styles.nav_list__item}
        >
          Blog
        </div> */}
        <div
          onClick={() => navigate('/contact')}
          className={styles.nav_list__item}
        >
          Contact
        </div>
      </div>
    </>
  );
};
const NavListC = (props) => {
  const { setNavOpen, searchQuery, setSearchQuery, handleSearchChange, searchResults, showResults, setShowResults } = props;
  const navigate = useNavigate();
  const searchRef = useRef(null);
  // let location = useLocation();
  // useEffect(() => {
  //   setNavOpen(false);
  // }, [location.pathname]);

  return (
    <>
      <nav id="mobile-navigation" className={styles.mobile_navigation} aria-label="Mobile navigation">
        <button
          type="button"
          className={styles.mobile_backdrop}
          onClick={() => setNavOpen(false)}
          aria-label="Close navigation menu"
        />
        <div className={styles.mobile_drawer}>
          <div className='p-4 flex justify-between'>
            <div onClick={() => navigate('/')} className={styles.navbar_logo}>
              <img
                src={Logo}
                loading='lazy'
                alt='NTP Tourism'
                width='100'
                height='100'
                style={{
                  width: '100px',
                }}
              />
            </div>
            <button
              type="button"
              className={styles.mobile_close}
              onClick={() => {
                setNavOpen(false);
              }}
              aria-label="Close navigation menu"
            >
              <img src={CloseIcon} alt='Close navigation menu icon' />
            </button>
          </div>

          {/* Mobile Search Bar */}
          <div className='px-4 mb-4' ref={searchRef}>
            <div className={styles.mobile_search_container}>
              <FaSearch className={styles.search_icon} />
              <input
                type="text"
                placeholder="Search tours..."
                value={searchQuery}
                onChange={handleSearchChange}
                className={styles.mobile_search_input}
                aria-label="Search tours"
              />
            </div>

            {showResults && searchResults && searchResults.length > 0 && (
              <div className={styles.mobile_search_results}>
                {searchResults.map((tour) => (
                  <div
                    key={tour.id}
                    className={styles.search_result_item}
                    onClick={() => {
                      navigate(tourPath(tour));
                      setSearchQuery('');
                      setShowResults(false);
                      setNavOpen(false);
                    }}
                  >
                    <div className={styles.search_result_title}>{tour.title}</div>
                    <div className={styles.search_result_location}>{tour.location}</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <ul>
            <li
              onClick={() => {
                navigate('/');
                setNavOpen(false);
              }}
              className={styles.navlist__mobile}
            >
              Home
            </li>
            <li
              onClick={() => {
                navigate('/departure');
                setNavOpen(false);
              }}
              className={styles.navlist__mobile}
            >
              Departure Date
            </li>
            <li
              onClick={() => {
                navigate('/discover');
                setNavOpen(false);
              }}
              className={styles.navlist__mobile}
            >
              <FaCompass className="inline-block mr-2" /> Discover
            </li>
            <li
              onClick={() => {
                navigate('/gallery');
                setNavOpen(false);
              }}
              className={styles.navlist__mobile}
            >
              Gallery
            </li>
            <li className={styles.navlist__mobile}>
              <Link to="/faqs" onClick={() => setNavOpen(false)}>
              FAQs
              </Link>
            </li>
            <li
              onClick={() => {
                navigate('/about');
                setNavOpen(false);
              }}
              className={styles.navlist__mobile}
            >
              About Us
            </li>
            <li
              onClick={() => {
                navigate('/blogs');
                setNavOpen(false);
              }}
              className={styles.navlist__mobile}
            >
              Blog
            </li>
            <li
              onClick={() => {
                navigate('/contact');
                setNavOpen(false);
              }}
              className={styles.navlist__mobile}
            >
              Contact
            </li>
          </ul>

          <div>
            <hr
              className='mt-5'
              style={{
                borderColor: 'grey',
              }}
            />
            <div
              className='ml-4 mt-6 '
              style={{
                marginBottom: '100px',
              }}
            >
              <span className='uppercase '>Connect to us</span>
              <div className='flex  gap-4 mt-6 '>
                <div
                  // className={`cursor-pointer ${styles.facebook}`}
                  onClick={() =>
                    window.open(
                      'https://www.facebook.com/profile.php?id=61555900903887'
                    )
                  }
                >
                  <svg
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M22.5 12.4062C22.5 6.88625 18.02 2.40625 12.5 2.40625C6.98 2.40625 2.5 6.88625 2.5 12.4062C2.5 17.2463 5.94 21.2762 10.5 22.2062V15.4062H8.5V12.4062H10.5V9.90625C10.5 7.97625 12.07 6.40625 14 6.40625H16.5V9.40625H14.5C13.95 9.40625 13.5 9.85625 13.5 10.4062V12.4062H16.5V15.4062H13.5V22.3563C18.55 21.8563 22.5 17.5963 22.5 12.4062Z'
                      fill='#FF7F00'
                    />
                  </svg>
                </div>
                <div
                  className={`cursor-pointer ${styles.instagram}`}
                  onClick={() =>
                    window.open('https://www.instagram.com/ntptourism/')
                  }
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='25'
                    height='25'
                    viewBox='0 0 25 25'
                    fill='none'
                  >
                    <path
                      d='M8.3 2.40625H16.7C19.9 2.40625 22.5 5.00625 22.5 8.20625V16.6063C22.5 18.1445 21.8889 19.6198 20.8012 20.7075C19.7135 21.7952 18.2383 22.4062 16.7 22.4062H8.3C5.1 22.4062 2.5 19.8063 2.5 16.6063V8.20625C2.5 6.66799 3.11107 5.19274 4.19878 4.10503C5.28649 3.01732 6.76174 2.40625 8.3 2.40625ZM8.1 4.40625C7.14522 4.40625 6.22955 4.78553 5.55442 5.46067C4.87928 6.1358 4.5 7.05147 4.5 8.00625V16.8062C4.5 18.7962 6.11 20.4062 8.1 20.4062H16.9C17.8548 20.4062 18.7705 20.027 19.4456 19.3518C20.1207 18.6767 20.5 17.761 20.5 16.8062V8.00625C20.5 6.01625 18.89 4.40625 16.9 4.40625H8.1ZM17.75 5.90625C18.0815 5.90625 18.3995 6.03795 18.6339 6.27237C18.8683 6.50679 19 6.82473 19 7.15625C19 7.48777 18.8683 7.80571 18.6339 8.04013C18.3995 8.27455 18.0815 8.40625 17.75 8.40625C17.4185 8.40625 17.1005 8.27455 16.8661 8.04013C16.6317 7.80571 16.5 7.48777 16.5 7.15625C16.5 6.82473 16.6317 6.50679 16.8661 6.27237C17.1005 6.03795 17.4185 5.90625 17.75 5.90625ZM12.5 7.40625C13.8261 7.40625 15.0979 7.93303 16.0355 8.87072C16.9732 9.8084 17.5 11.0802 17.5 12.4062C17.5 13.7323 16.9732 15.0041 16.0355 15.9418C15.0979 16.8795 13.8261 17.4062 12.5 17.4062C11.1739 17.4062 9.90215 16.8795 8.96447 15.9418C8.02678 15.0041 7.5 13.7323 7.5 12.4062C7.5 11.0802 8.02678 9.8084 8.96447 8.87072C9.90215 7.93303 11.1739 7.40625 12.5 7.40625ZM12.5 9.40625C11.7044 9.40625 10.9413 9.72232 10.3787 10.2849C9.81607 10.8475 9.5 11.6106 9.5 12.4062C9.5 13.2019 9.81607 13.965 10.3787 14.5276C10.9413 15.0902 11.7044 15.4062 12.5 15.4062C13.2956 15.4062 14.0587 15.0902 14.6213 14.5276C15.1839 13.965 15.5 13.2019 15.5 12.4062C15.5 11.6106 15.1839 10.8475 14.6213 10.2849C14.0587 9.72232 13.2956 9.40625 12.5 9.40625Z'
                      fill='#FF7F00'
                    />
                  </svg>{' '}
                </div>

                <div
                  className={`cursor-pointer ${styles.whatsapp}`}
                  style={{ width: '22px' }}
                  onClick={() => window.open(' https://wa.me/9779851054995')}
                >
                  <img src={WHATSAPP} alt='WhatsApp' />
                </div>
                <div
                  className={`cursor-pointer ${styles.twitter} w-[40px]`}
                  style={{ width: '31px' }}
                  onClick={() =>
                    window.open('https://www.youtube.com/@ntptourism')
                  }
                >
                  <img src={YOUTUBE} alt='YouTube' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Index;
